import { keyframes } from 'styled-components'

import { colours } from '@/theme/tokens'

export const Colours = colours

export const fadeIn = keyframes`
    from {
      opacity: 0;
      font-size: 0rem;
    }
    to {
      opacity: 1;
      font-size: 1rem;
    }
  `
